import React, { useEffect, useState } from "react";
import { useDrop } from "react-dnd";
import { ImageSortingTask, PlacementPoint } from "data-models/task-models";
import { Center, Image, Stack, Text } from "@chakra-ui/react";
import ImagePlacementItem from "./ImagePlacementItem";
import { useFollowUp } from "providers/FollowUpProvider";
import {
  tasksWithDropImages,
  IMAGE_BOX_WIDTH,
  IMAGE_BOX_HEIGHT,
  DROP_IMAGE_WRAPPER_HEIGHT,
} from "./tasksWithDropImages";
import { apiBase } from "services/config";

interface ImagePlacementPointProps {
  currentPoint: PlacementPoint;
  onChange: (point: PlacementPoint, item: string) => void;
  text: number | string;
  answerIndex: number;
  dropImages?: string;
  //draggedItemProp?: string
}

export default function ImagePlacementPoint({
  onChange,
  currentPoint,
  answerIndex,
  text,
  dropImages,
}: ImagePlacementPointProps) {
  const { currentTask } = useFollowUp();
  const task = currentTask as ImageSortingTask;
  const [isSortShapes, setIsSortShapes] = useState(false);
  const dropImage = tasksWithDropImages.includes(currentTask.id);
  const borderWidth = task.name[1] === "Shapes" ? "0" : dropImage ? "2px" : "1px";

  const getCurrentImageSlug = (task: ImageSortingTask, answerIndex: number) => {
    const answer = task.answerOptions[answerIndex];
    const placedImageId = answer.placedAtPoint;

    if (placedImageId) {
      const imageSlug = task.images.find(image => image.includes(placedImageId));

      return imageSlug;
    }
    return null;
  };
  const imageSlug = getCurrentImageSlug(task, answerIndex);

  const changeNewPoint = (item: any, _point: any) => {
    const placement = item.image.split("/assets/")[1];

    if (placement.includes("mathematics") || placement.includes("science") || placement.includes("sprak")) {
      onChange(currentPoint, placement.split("/")[1].split(".")[0]);
    } else {
      onChange(currentPoint, placement.split("/")[1].split("-")[1].split(".")[0]);
    }
  };

  const [_, drop] = useDrop(
    () => ({
      accept: "image",
      drop: (item, monitor) => changeNewPoint(item, monitor.getClientOffset()),
    }),
    [currentPoint, imageSlug],
  );

  /// fetch the answers and set item url for the placedAtPoint not null'
  useEffect(() => {
    if (currentTask.name[1] === "Shapes") {
      setIsSortShapes(true);
    }
  }, [currentTask]);

  const finalText = text || "";

  return (
    <Center
      width="full"
      height={dropImage ? DROP_IMAGE_WRAPPER_HEIGHT : "full"}
      borderRadius="2xl"
      borderWidth={borderWidth}
      borderStyle={dropImage ? "solid" : "dashed"}
      borderColor="white"
      color="overlayWhite"
      fontSize="48"
      fontWeight="semibold"
      position="relative"
      ref={drop}
    >
      {dropImage ? (
        imageSlug ? (
          <Stack
            pos="absolute"
            top="10%"
            w={IMAGE_BOX_WIDTH}
            h={IMAGE_BOX_HEIGHT}
            justifyContent="center"
            alignItems="center"
          >
            <ImagePlacementItem ipa={imageSlug} />
          </Stack>
        ) : (
          <>
            <Stack
              w={IMAGE_BOX_WIDTH}
              h={IMAGE_BOX_HEIGHT}
              bg="overlayWhite"
              borderColor="white"
              pos="absolute"
              top="5%"
              borderRadius="2xl"
            />
          </>
        )
      ) : isSortShapes ? (
        imageSlug ? (
          <ImagePlacementItem ipa={imageSlug} />
        ) : (
          <Image src={String(text)} width="80%" />
        )
      ) : imageSlug ? (
        <ImagePlacementItem ipa={imageSlug} />
      ) : (
        finalText
      )}

      {dropImage && dropImages && <img src={apiBase + dropImages} className="drop-image" />}
    </Center>
  );
}
